import React from "react";
const QuotationSideBarWrapper = (props) => {
  return (
    <div className="col-md-12">
      <div className="form-group">
        <label htmlFor="exampleInput">{props.label}</label>
        {props.children}
      </div>
    </div>
  );
};
const QuotationSideBar = ({
  selectedData,
  _doToogleRemarks,
  getQuotationRemarks,
}) => {
  return (
    <>
      <div className="col-md-12 text-right">
        <button
          className="btn-link btn-link--bold"
          type="button"
          onClick={() => (
            _doToogleRemarks("show"),
            getQuotationRemarks(selectedData.work_request_id)
          )}
        >
          Remarks
        </button>
      </div>
      <QuotationSideBarWrapper label='Issue Description'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.issue_description}
        />
      </QuotationSideBarWrapper>

      <QuotationSideBarWrapper label="Asset Name">
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.asset_name}
        />
      </QuotationSideBarWrapper>
      <QuotationSideBarWrapper label='Work Start Date'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.work_request_start_date}
        />
      </QuotationSideBarWrapper>
      <QuotationSideBarWrapper label='Priority'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.work_request_priority}
        />
      </QuotationSideBarWrapper>
      <QuotationSideBarWrapper label='Created By'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.created_by}
        />
      </QuotationSideBarWrapper>
      <QuotationSideBarWrapper label='Vendor Name'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.vendor_company_name}
        />
      </QuotationSideBarWrapper>
      <QuotationSideBarWrapper label='Technician Name'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.technician_name}
        />
      </QuotationSideBarWrapper>
      <QuotationSideBarWrapper label='TechniCian Number'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.technician_number}
        />
      </QuotationSideBarWrapper>
      {/* <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="exampleInput">Check List Name</label>
          <input
            type="text"
            className="form-control"
            disabled
            value={selectedData.checklist_name}
          />
        </div>
      </div> */}
      <QuotationSideBarWrapper label='Quotation Required'>
        <input
          type="checkbox"
          checked={selectedData.quotation_required == 0 ? false : true}
          disabled
          style={{ width: 20, height: 20, display: "block" }}
        />
      </QuotationSideBarWrapper>
      <QuotationSideBarWrapper label='Quotation Total'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.quotation_total}
        />
      </QuotationSideBarWrapper>
      <QuotationSideBarWrapper label='Quotation Status'>
        <input
          type="text"
          className="form-control"
          disabled
          value={selectedData.quotation_request_status_desc}
        />
      </QuotationSideBarWrapper>
    </>
  );
};

export default QuotationSideBar;
